var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoal15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    transform: "translate(0)",
    fill: "#56c02b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.56,83.7v9.159h3.377V91.6H321.1V83.7Z",
    transform: "translate(-283.769 -74.326)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.539,
    height: 9.158,
    transform: "translate(40.005 9.374)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.97,92.859h1.539V88.82h1.54V87.577h-1.54V84.957h2.064V83.7h-3.6Z",
    transform: "translate(-337.413 -74.326)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M419.39,92.859h3.671V91.6h-2.132V88.82h1.527V87.577h-1.527V84.957h2.132V83.7H419.39Z",
    transform: "translate(-372.418 -74.326)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.22,87.8v3.963h.034L75.917,89h.035v17.286h3.8V83.7H76.717Z",
    transform: "translate(-65.019 -74.326)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.447,90.88a3.423,3.423,0,0,0-3.2,1.568h-.034V86.816h6.529v-3.1h-9.992V96.443h3.463v-.5c0-1.331.6-2.064,1.664-2.064,1.167,0,1.634.8,1.634,2.033v5.462c0,1.2-.433,2.031-1.6,2.031-1.3,0-1.763-.866-1.763-2.2v-2.83H151.68v2.566c0,3.429,1.365,5.627,5.229,5.627,3.83,0,5.4-2.032,5.4-5.162V95.875c0-3.564-1.831-5-3.863-5",
    transform: "translate(-134.692 -74.343)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M319.5,209.806v-4.412a2.325,2.325,0,1,1,4.642,0v4.412a2.325,2.325,0,1,1-4.642,0m3.108.242v-4.9c0-.552-.242-.942-.793-.942s-.784.39-.784.942v4.9c0,.552.242.943.784.943s.793-.391.793-.943",
    transform: "translate(-283.716 -180.202)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M370,207.291v5.73H368.71V203.9h1.508l1.654,5.233V203.9h1.278v9.121h-1.344Z",
    transform: "translate(-327.414 -181.063)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M438.04,203.9h1.533v7.87H441.4v1.251H438.04Z",
    transform: "translate(-388.979 -181.063)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M472.11,213.021l1.723-9.121h1.749l1.736,9.121h-1.575l-.286-1.668h-1.625l-.268,1.668Zm1.925-2.892h1.224l-.606-3.659h-.013Z",
    transform: "translate(-419.234 -181.063)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M525.492,207.291v5.73H524.2V203.9h1.508l1.654,5.233V203.9h1.278v9.121H527.3Z",
    transform: "translate(-465.49 -181.063)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M577.318,206.349v4.225c0,1.4-.578,2.447-2.22,2.447H572.73V203.9H575.1c1.642,0,2.22,1.036,2.22,2.449m-2.408,5.421c.63,0,.875-.376.875-.927v-4.777a.8.8,0,0,0-.875-.915h-.646v6.619Z",
    transform: "translate(-508.584 -181.063)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.557 44.492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.058,676.12a.248.248,0,0,1,.248.248v8.156a.246.246,0,0,1-.248.248h-3.3a.248.248,0,0,1-.249-.248v-8.156a.248.248,0,0,1,.249-.248Z",
    transform: "translate(-372.665 -644.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.607,784.62H255.219a.255.255,0,0,0-.249.257V788.2a.247.247,0,0,0,.249.244h54.388a.251.251,0,0,0,.25-.244v-3.324a.258.258,0,0,0-.25-.257",
    transform: "translate(-254.97 -741.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.634,843.61H255.245a.249.249,0,0,0-.245.245v3.334a.25.25,0,0,0,.249.245h54.385a.252.252,0,0,0,.25-.245v-3.334a.251.251,0,0,0-.25-.245",
    transform: "translate(-254.997 -793.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.3,581.436a8.042,8.042,0,0,0-4.7-1.773,6.286,6.286,0,0,0-4.368,1.856.469.469,0,0,0-.146.336v.307a.469.469,0,0,0,.156.372.435.435,0,0,0,.383.09.6.6,0,0,0,.1-.026.751.751,0,0,0,.272-.172,4.407,4.407,0,0,1,2.178-.448,8.209,8.209,0,0,1,5.6,2.352l.05.045a.657.657,0,0,0,.473.2.641.641,0,0,0,.46-.193l.045-.046a8.257,8.257,0,0,1,5.611-2.352,4.467,4.467,0,0,1,2.184.448.808.808,0,0,0,.3.184.665.665,0,0,0,.318,0,.466.466,0,0,0,.343-.448V581.9a.473.473,0,0,0-.146-.336,6.3,6.3,0,0,0-4.421-1.9,7.987,7.987,0,0,0-4.7,1.775",
    transform: "translate(-533.016 -559.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.786,397.853a.455.455,0,0,0-.237.287l-.055.181a.46.46,0,0,0,.072.409.448.448,0,0,0,.336.184.179.179,0,0,0,.068,0,.576.576,0,0,0,.262-.067,1.366,1.366,0,0,1,.336-.037,4.72,4.72,0,0,1,3.885,2.538l.019.036a.553.553,0,0,0,.347.278.659.659,0,0,0,.174.027.588.588,0,0,0,.274-.067l.036-.018a5.42,5.42,0,0,1,2.426-.6,3.693,3.693,0,0,1,2.481.794.627.627,0,0,0,.176.2,1.282,1.282,0,0,0,.177.085.367.367,0,0,0,.081.011.22.22,0,0,0,.048,0,.471.471,0,0,0,.216-.054.459.459,0,0,0,.231-.279l.046-.16a.418.418,0,0,0,.019-.132.447.447,0,0,0-.064-.234,4.089,4.089,0,0,0-3.689-2.216,5.784,5.784,0,0,0-1.958.367,4.745,4.745,0,0,0-3.668-2.055,4.532,4.532,0,0,0-2.038.515",
    transform: "translate(-576.873 -397.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.646,456l.016.245a.465.465,0,0,0,.584.421.615.615,0,0,0,.08-.025.607.607,0,0,0,.235-.174,3.979,3.979,0,0,1,2.074-.472,6.718,6.718,0,0,1,4.3,1.627l.038.039a.647.647,0,0,0,.42.158h.04a.637.637,0,0,0,.427-.2l.036-.042a6.532,6.532,0,0,1,4.768-2.2,3.232,3.232,0,0,1,1.418.259.723.723,0,0,0,.283.147.544.544,0,0,0,.314-.015.464.464,0,0,0,.308-.467l-.012-.213a.46.46,0,0,0-.163-.324,5.332,5.332,0,0,0-3.479-1.369,6.5,6.5,0,0,0-4.071,1.68,6.789,6.789,0,0,0-3.629-1.205,5.19,5.19,0,0,0-3.858,1.783.482.482,0,0,0-.127.348",
    transform: "translate(-488.226 -447.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.91,410.514a5.9,5.9,0,0,1,5.9-5.9c.128,0,.252.011.377.019a7.973,7.973,0,1,1,15.12,4.081,8.913,8.913,0,0,1-1.935,17.617c-.36,0-11.9-.069-11.9-.069h0a6.3,6.3,0,0,1-4.592-10.634A5.89,5.89,0,0,1,271.91,410.514Z",
    transform: "translate(-270.013 -397.252)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal15);
export default __webpack_public_path__ + "static/media/goal-15.1de3785176c3c88b4e7669d3a268af9e.svg";
export { ForwardRef as ReactComponent };